export const en = {

    translations: {

        ar_tikrai_istrinti_savininka: 'Are you sure you want to delete this owner? Their patients will remain in the system.',
        atnaujinti_sarasa: 'Refresh list',
        ar_tikrai_istrinti_pacienta: 'Are you sure you want to delete this patient?',
        pdf_atsisiusti: 'Download PDF',
        pdf_ruosiamas: 'Preparing images...',
        pdf_ios_info: 'Safari on iPhone and iPad only previews the first page, so tap "Open PDF" to view the whole document and save or share it.',
    }
}

